const ContactDetailsFactory = function ($resource) {
    return {
        retrieveContactDetails: $resource(
            __baseApiUrl__ + "/participant-web-services/rest/retrieveContactDetails",
            {},
            {
                query: {
                    method: "GET",
                    isArray: false
                }
            }
        )
    };
};

ContactDetailsFactory.$inject = ["$resource", "$window"];
export default ContactDetailsFactory;
